import React from 'react';

export const Button = React.forwardRef<HTMLButtonElement, React.PropsWithChildren<React.ButtonHTMLAttributes<HTMLButtonElement>>>(function Button(
    { className, children, ...rest },
    ref,
) {
    return (
        <button
            ref={ref}
            type='button'
            className={
                'h-[34px] flex items-center justify-center cursor-pointer bg-indigo-bright rounded-[4px] text-ash-grey px-[12px] active:opacity-80 disabled:opacity-50 disabled:cursor-not-allowed ' +
                (className ?? '')
            }
            {...rest}
        >
            {children}
        </button>
    );
});
